/**
 * Copy strings + builders for World Cup squad leave / kick flows.
 * Keeping all user-visible strings here lets the hook stay focused on flow control.
 */

export const WORLD_CUP_MEMBERSHIP_COPY = {
  LEAVE_DIALOG_TITLE: 'Leave squad',
  LEAVE_DIALOG_CONFIRM: 'Leave',
  LEAVE_DIALOG_CANCEL: 'Cancel',
  KICK_DIALOG_TITLE: 'Remove from squad',
  KICK_DIALOG_CONFIRM: 'Remove',
  KICK_DIALOG_CANCEL: 'Cancel',
  SQUAD_DELETED_SNACKBAR: 'Squad deleted — no humans left',
  LEFT_SQUAD_SNACKBAR: 'Left squad',
  MEMBER_REMOVED_SNACKBAR: 'Member removed',
  ERROR_TITLE: 'Error',
  LEAVE_ERROR_FALLBACK: 'Could not leave squad.',
  KICK_ERROR_FALLBACK: 'Could not remove member.',
  NOT_MEMBER_ERROR: 'Not a member of this squad',
  THIS_SQUAD_LABEL: 'this squad',
} as const;

export const buildLeaveSquadMessage = (squadLabel: string): string =>
  `Are you sure you want to leave ${squadLabel}? If you're an admin, another member will be promoted automatically.`;

export const buildKickMemberMessage = (memberName: string): string =>
  `Remove ${memberName} from this squad?`;

export const buildSquadNameLabel = (squadName: string | undefined): string =>
  squadName ? `"${squadName}"` : WORLD_CUP_MEMBERSHIP_COPY.THIS_SQUAD_LABEL;
